"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketSubmissionPrizeDTOList = void 0;
var TicketSubmissionPrizeDTO_1 = require("./TicketSubmissionPrizeDTO");
var types_1 = require("./types");
var TicketSubmissionPrizeDTOList = /** @class */ (function (_super) {
    __extends(TicketSubmissionPrizeDTOList, _super);
    function TicketSubmissionPrizeDTOList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getPrizeTitle = function () { return 'Ticket Validated'; };
        _this.getPrizeMessage = function (isScannedEntry) {
            var message = '';
            if (_this.length > 0) {
                var entries = _this.filter(function (x) { return x.prizeType === types_1.PrizeType.ENTRY; });
                var points = _this.filter(function (x) { return x.prizeType === types_1.PrizeType.LOYALTY_POINTS; });
                if (entries.length === 1 && points.length === 1) {
                    message = "You've earned " + points[0].amount + " Points and have been entered into a Second Chance Draw!";
                }
                else if (entries.length === 1) {
                    message = (isScannedEntry ? 'Scanning' : 'Adding') + " this ticket has successfully entered you into a Second Chance Draw";
                }
                else if (points.length === 1) {
                    message = "Ticket successfully " + (isScannedEntry ? 'scanned. Scan' : 'entered. Enter') + " another, or go back if done.";
                }
            }
            return message;
        };
        _this.getPoints = function (isDigitalReveal) {
            if (_this.length > 0) {
                var points = _this.filter(function (x) {
                    return !!isDigitalReveal
                        ? x.prizeType === types_1.PrizeType.LOYALTY_POINTS && !!x.token && !x.preassigned
                        : x.prizeType === types_1.PrizeType.LOYALTY_POINTS && !x.token && !x.preassigned;
                });
                if (points.length >= 1) {
                    return points[0].amount ? points[0].amount : 0;
                }
            }
            return -1;
        };
        _this.getEntries = function (isDigitalReveal) {
            var entries = new TicketSubmissionPrizeDTOList();
            if (_this.length > 0) {
                var entriesArray = _this.filter(function (x) {
                    return !!isDigitalReveal ? x.prizeType === types_1.PrizeType.ENTRY && !!x.token : x.prizeType === types_1.PrizeType.ENTRY && !x.token;
                });
                entries = TicketSubmissionPrizeDTOList.TicketSubmissionPrizeDTOArrayToTicketSubmissionPrizeDTOList(entriesArray);
            }
            return entries;
        };
        _this.hasWinningTicket = function () { return (_this.length <= 0 ? false : !!_this.find(function (x) { return !!x.hasWinningTicket; })); };
        return _this;
    }
    TicketSubmissionPrizeDTOList.JsonToTicketSubmissionPrizeDTOList = function (data) {
        var ticketSubmissionPrizeDTOList = new TicketSubmissionPrizeDTOList();
        data.forEach(function (ticketSubmissionPrizeDTO) {
            return ticketSubmissionPrizeDTOList.push(TicketSubmissionPrizeDTO_1.TicketSubmissionPrizeDTO.JsonToTicketSubmissionPrizeDTO(ticketSubmissionPrizeDTO));
        });
        return ticketSubmissionPrizeDTOList;
    };
    TicketSubmissionPrizeDTOList.TicketSubmissionPrizeDTOArrayToTicketSubmissionPrizeDTOList = function (data) {
        var ticketSubmissionPrizeDTOList = new TicketSubmissionPrizeDTOList();
        data.forEach(function (ticketSubmissionPrizeDTO) { return ticketSubmissionPrizeDTOList.push(ticketSubmissionPrizeDTO); });
        return ticketSubmissionPrizeDTOList;
    };
    return TicketSubmissionPrizeDTOList;
}(Array));
exports.TicketSubmissionPrizeDTOList = TicketSubmissionPrizeDTOList;
//# sourceMappingURL=TicketSubmissionPrizeDTOList.js.map